import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledPanelIcon = styled(SWReactIcons)`
    display: flex;
    height: unset !important;
    margin-right: 6px;

    & svg {
        width: 100%;

        & path,
        & use {
            fill: ${colorsPalettes.carbon["0"]};
        }
    }
`;

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["0"])};
    text-transform: capitalize;
    user-select: none;
`;

export const StyledPanelTitleWithIcon = styled(FlexRow)`
    margin-left: 34px;
`;
